import { GET_IMPORTHISTORY, GET_IMPORTHISTORY_LIST } from '../constant';
import {
	getImportHistoriesApi,
	initBucketsApi,
	updateBucketsApi,
} from '../../api';

export const getImportHistories = (data) => ({
	type: GET_IMPORTHISTORY_LIST,
	data,
});

export const addImportHistory = (data) => ({
	type: GET_IMPORTHISTORY,
	data,
});

export const getImportHistoriesAsync = (params) => {
	const pageSize = 15;
	params = { ...params, pageSize };
	return (dispatch) => {
		return getImportHistoriesApi(params)
			.then((data) => {
				if (data.errorCode.trim().length === 0) {
					const totalCount = (data.value as any)?.total ?? 0;
					const totalpage =
						parseInt(parseInt(totalCount) / pageSize + '') +
						(totalCount % pageSize > 0 ? 1 : 0);
					dispatch(
						getImportHistories({
							data: (data.value as any)?.data ?? [],
							total: totalpage,
						})
					);
				} else {
					console.error(`${data.errorCode}:: ${data.errorMessage}`);
				}
			})
			.catch((error) => {
				throw error;
			});
	};
};

export const initBucketsAsync = (data) => async (dispatch) => {
	try {
		const response = await initBucketsApi(data);
		if (response.errorCode.trim().length === 0) {
			dispatch(addImportHistory(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateBucketsAsync = (data) => async (dispatch) => {
	try {
		const response = await updateBucketsApi(data);
		if (response.errorCode.trim().length === 0) {
			dispatch(addImportHistory(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};
